import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type State = {
  deletablePublisher: {
    id: number;
    title: string;
  } | null;
  setDeletablePublisher: (
    publisher: {
      id: number;
      title: string;
    } | null,
  ) => void;
};

export const usePublishersStore = create<State>()(
  subscribeWithSelector(
    immer((set) => ({
      deletablePublisher: null,
      setDeletablePublisher(publisher) {
        return set((state) => {
          state.deletablePublisher = publisher;
        });
      },
    })),
  ),
);
